var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, IconButton, Typography, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { MODOS, MENSAGENS, getDataFormatada, validarData, parseDate } from '../../../../../utils';
import { ROUTES, FUNCIONALIDADES } from '../../../../../routes';
import { BoxBotoes } from '../../../../../components/form_box';
import Loading from '../../../../../components/loading';
import { useParams } from 'react-router-dom';
import { BotaoFechar, BotaoAuxiliar } from '../../../../../components/botoes';
import { InputDados } from '../../../../../components/input_dados';
import { ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon } from '@mui/icons-material';
import GridComp from '../../../../../components/grid';
import { alterarOcorrencia as alterarOcorrenciaAPI, cadastrarOcorrencia, excluirOcorrencia, getTiposNaturezasCrimes, getReeducandoOcorrencias, STATUS_API, } from './services';
import { useAuth } from '../../../../../contexts/auth/AuthContext';
export var ReeducandosInformacoesLegais = function (props) {
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.REEDUCANDOS_OCORRENCIAS); }, [getAcoesFuncionalidade]);
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(true), LoadingInicio = _b[0], setLoadingInicio = _b[1];
    var _c = useParams(), id = _c.id, modo = _c.modo;
    var _d = useState([]), OcorrenciasReeducando = _d[0], setOcorrenciasReeducando = _d[1];
    var _e = useState([]), TiposNaturezasCrimesDisponiveis = _e[0], setTiposNaturezasCrimesDisponiveis = _e[1];
    var _f = useState(-1), TipoNaturezaCrimeSelecionado = _f[0], setTipoNaturezaCrimeSelecionado = _f[1];
    var _g = useState(''), DataOcorrencia = _g[0], setDataOcorrencia = _g[1];
    var _h = useState(), Descricao = _h[0], setDescricao = _h[1];
    var _j = useState(), NumeroProcesso = _j[0], setNumeroProcesso = _j[1];
    var _k = useState(false), PopupAberto = _k[0], setPopupAberto = _k[1];
    var _l = useState(), EditarID = _l[0], setEditarID = _l[1];
    var _m = useState(-1), EditarTipoNaturezaCrimeSelecionado = _m[0], setEditarTipoNaturezaCrimeSelecionado = _m[1];
    var _o = useState(''), EditarDataOcorrencia = _o[0], setEditarDataOcorrencia = _o[1];
    var _p = useState(), EditarDescricao = _p[0], setEditarDescricao = _p[1];
    var _q = useState(), EditarNumeroProcesso = _q[0], setEditarNumeroProcesso = _q[1];
    var setAbaAtiva = props.setAbaAtiva;
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, NaturezasCrimesAux, ReeducandoDadosAux, ocorrencias;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([getTiposNaturezasCrimes(), getReeducandoOcorrencias(id)])];
                case 1:
                    _a = _b.sent(), NaturezasCrimesAux = _a[0], ReeducandoDadosAux = _a[1];
                    if (NaturezasCrimesAux.Status == STATUS_API.ERRO) {
                        alert(NaturezasCrimesAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setTiposNaturezasCrimesDisponiveis(NaturezasCrimesAux);
                    }
                    if (ReeducandoDadosAux.Status == STATUS_API.ERRO) {
                        alert(ReeducandoDadosAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        ocorrencias = ReeducandoDadosAux.ocorrencias;
                        setOcorrenciasReeducando(ocorrencias);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID do Colaborador não informado');
                    _b.label = 3;
                case 3:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!TipoNaturezaCrimeSelecionado || TipoNaturezaCrimeSelecionado == -1) {
            alert("Tipo de Ocorr\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!DataOcorrencia || DataOcorrencia.trim() == '') {
            alert("Data da Ocorr\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(DataOcorrencia)) {
            alert("Data da Ocorr\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        return true;
    };
    var validarDadosEditar = function () {
        if (!EditarTipoNaturezaCrimeSelecionado || EditarTipoNaturezaCrimeSelecionado == -1) {
            alert("Tipo de Ocorr\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!EditarDataOcorrencia || EditarDataOcorrencia.trim() == '') {
            alert("Data da Ocorr\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!validarData(EditarDataOcorrencia)) {
            alert("Data da Ocorr\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_INVALIDO));
            return false;
        }
        return true;
    };
    var adicionarOcorrencia = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, ocorrencias;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        tipo_natureza_crime_id: TipoNaturezaCrimeSelecionado,
                        data: parseDate(DataOcorrencia),
                        numero_processo: NumeroProcesso,
                        descricao: Descricao,
                    };
                    return [4 /*yield*/, cadastrarOcorrencia(Dados, id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        ocorrencias = Resp.dados.ocorrencias;
                        setOcorrenciasReeducando(ocorrencias !== null && ocorrencias !== void 0 ? ocorrencias : []);
                        limparSelecao();
                    }
                    else {
                        alert(Resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarOcorrencia = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, OcorrenciasAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDadosEditar())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        tipo_natureza_crime_id: EditarTipoNaturezaCrimeSelecionado,
                        data: parseDate(EditarDataOcorrencia),
                        numero_processo: EditarNumeroProcesso,
                        descricao: EditarDescricao,
                    };
                    return [4 /*yield*/, alterarOcorrenciaAPI(Dados, EditarID ? EditarID.toString() : '')];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        OcorrenciasAtualizados = OcorrenciasReeducando.map(function (Item) {
                            if (Item.id == EditarID) {
                                return __assign(__assign({}, Item), Dados);
                            }
                            else {
                                return Item;
                            }
                        });
                        setOcorrenciasReeducando(OcorrenciasAtualizados);
                        setPopupAberto(false);
                        limparPopup();
                    }
                    else {
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, OcorrenciasAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirOcorrencia(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        OcorrenciasAtualizados = OcorrenciasReeducando.filter(function (Item) { return Item.id != +id; });
                        setOcorrenciasReeducando(OcorrenciasAtualizados);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var limparSelecao = function () {
        setTipoNaturezaCrimeSelecionado(-1);
        setDataOcorrencia('');
        setDescricao('');
        setNumeroProcesso('');
    };
    var limparPopup = function () {
        setEditarID(undefined);
        setEditarTipoNaturezaCrimeSelecionado(-1);
        setEditarDataOcorrencia('');
        setEditarDescricao('');
        setEditarNumeroProcesso('');
    };
    var COLUNAS_TERMOS = [
        {
            field: 'tipo_natureza_crime_id',
            headerName: 'Natureza do Crime',
            width: 350,
            valueGetter: function (_value, row) { var _a; return (_a = row.tipo_natureza_crime) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'numero_processo',
            headerName: 'N.º Processo',
            width: 150,
        },
        {
            field: 'data',
            headerName: 'Data de Ocorrência',
            width: 200,
            valueGetter: function (value, _row) { return getDataFormatada(value); },
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            width: 400,
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 80,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                var _a;
                                abrirPopup((_a = params.row) === null || _a === void 0 ? void 0 : _a.id);
                            }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })), _jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { var _a; return handleDelete((_a = params.row) === null || _a === void 0 ? void 0 : _a.id); }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['EXCLUIR'] }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))] }))); },
        },
    ];
    var abrirPopup = function (OcorrenciaID) { return __awaiter(void 0, void 0, void 0, function () {
        var OcorrenciaAux, id_1, tipo_natureza_crime_id, data, descricao, numero_processo;
        return __generator(this, function (_a) {
            setLoading(true);
            OcorrenciaAux = OcorrenciasReeducando.find(function (Item) { return Item.id == +OcorrenciaID; });
            if (OcorrenciaAux) {
                id_1 = OcorrenciaAux.id, tipo_natureza_crime_id = OcorrenciaAux.tipo_natureza_crime_id, data = OcorrenciaAux.data, descricao = OcorrenciaAux.descricao, numero_processo = OcorrenciaAux.numero_processo;
                setEditarID(id_1);
                setEditarTipoNaturezaCrimeSelecionado(tipo_natureza_crime_id);
                setEditarDataOcorrencia(getDataFormatada(data));
                setEditarDescricao(descricao);
                setEditarNumeroProcesso(numero_processo);
            }
            setLoading(false);
            setPopupAberto(true);
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAberto(false);
        }
    };
    return (_jsx(_Fragment, { children: !LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ mt: 5 }, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Ocorr\u00EAncia" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'natureza-crime', label: 'Natureza do Crime', placeholder: 'Natureza do Crime', value: TipoNaturezaCrimeSelecionado, onChange: function (event) {
                                            setTipoNaturezaCrimeSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposNaturezasCrimesDisponiveis === null || TiposNaturezasCrimesDisponiveis === void 0 ? void 0 : TiposNaturezasCrimesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'numero-processo', label: 'N.\u00BA Processo', value: NumeroProcesso, onChange: function (event) { return setNumeroProcesso(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'data-ocorrencia', label: 'Data da Ocorr\u00EAncia', mask: '99/99/9999', value: DataOcorrencia, onChange: function (event) { return setDataOcorrencia(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'descricao', label: 'Descri\u00E7\u00E3o', value: Descricao, onChange: function (event) { return setDescricao(event.target.value); }, multiline: true, maxRows: 4, disabled: DESABILITAR_CAMPOS }) })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecao, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarOcorrencia, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: OcorrenciasReeducando, columns: COLUNAS_TERMOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(6); } }, { children: "Voltar" })), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.REEDUCANDOS })] }))] })), _jsxs(Dialog, __assign({ open: PopupAberto, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Ocorr\u00EAncia" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarID, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-ocorrencia', label: 'Natureza do Crime', placeholder: 'Natureza do Crime', value: EditarTipoNaturezaCrimeSelecionado, onChange: function (event) {
                                            setEditarTipoNaturezaCrimeSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposNaturezasCrimesDisponiveis === null || TiposNaturezasCrimesDisponiveis === void 0 ? void 0 : TiposNaturezasCrimesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-numero-processo', label: 'N.\u00BA Processo', value: EditarNumeroProcesso, onChange: function (event) { return setEditarNumeroProcesso(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-data-ocorrencia', label: 'Data da Ocorr\u00EAncia', mask: '99/99/9999', value: EditarDataOcorrencia, onChange: function (event) { return setEditarDataOcorrencia(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-descricao', label: 'Descri\u00E7\u00E3o', value: EditarDescricao, onChange: function (event) { return setEditarDescricao(event.target.value); }, multiline: true, maxRows: 4, disabled: DESABILITAR_CAMPOS }) }))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarOcorrencia, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), loading && _jsx(Loading, {})] })) }));
};
export default ReeducandosInformacoesLegais;
